var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03556 9.3224C0.966481 9.11513 0.966415 8.89073 1.03538 8.68343C2.42374 4.50972 6.3608 1.5 11.0008 1.5C15.6387 1.5 19.5742 4.50692 20.9643 8.6776C21.0334 8.88487 21.0335 9.10927 20.9645 9.31658C19.5762 13.4903 15.6391 16.5 10.9991 16.5C6.36121 16.5 2.42565 13.4931 1.03556 9.3224Z",
    stroke: "#A3AED0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9C14 10.6569 12.6569 12 11 12C9.34316 12 8.00001 10.6569 8.00001 9C8.00001 7.34315 9.34316 6 11 6C12.6569 6 14 7.34315 14 9Z",
    stroke: "#A3AED0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.a87e1b9485b0c647dba6632edfe506e6.svg";
export { ForwardRef as ReactComponent };